/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import CreatableSelect from 'react-select/creatable';

const SCHEDULE_DAYS = [
  { label: 'Mon', value: 1 },
  { label: 'Tue', value: 2 },
  { label: 'Wed', value: 3 },
  { label: 'Thu', value: 4 },
  { label: 'Fri', value: 5 },
  { label: 'Sat', value: 6 },
  { label: 'Sun', value: 7 },
];

const SCHEDULE_TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
  'UTC',
];

async function sendData(token, id, data) {
  return fetch(process.env.REACT_APP_API_URL + '/crud/clients/' + id,
    {
      method: 'PUT',
      headers: {
        'Authorization': 'Bearer '+ token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(data => data.json())
    .catch(function(error) {
      return error;
  });
}

async function clientData(token, id) {
  return fetch(process.env.REACT_APP_API_URL + '/crud/clients/' + id,
    {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer '+ token,
        'Content-Type': 'application/json'
      },
    })
    .then(data => data.json())
    .catch(function(error) {
      return error;
  });
}

export default function ClientEdit(props) {
  const [formData, setFormData] = useState({
    'clinic_id': '',
    'company_id': '',
    'name': '',
    'active': 1,
    metadata:{
      'send_txt': true,
      'send_email': true,
      'send_request_on_create': true,
    }

  });
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [response, setResponse] = useState(false);
  const { id } = useParams();

  const handleInputChange = async e => {
    console.log(e.target);
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  }

  const handleActiveToggle = e => {
    setFormData({ ...formData, active: e.target.checked ? 1 : 0 });
  }

  const handleInputCheckChange = async e => {
    console.log(e.target);
    const { id, value, checked } = e.target;
    setFormData({ ...formData, metadata:{...formData.metadata, [id]: checked} });
    console.log(formData)

  }

  const handleSubmit = async e => {
    e.preventDefault();
    console.log(formData);
    const response = await sendData(props.token, id, formData);
    if (!response) {
        setError(true);
        return
    }
    if (response.error) {
      setError(true);
      setResponse(response);
      console.log(response);
      return
    }
    setError(false);
    setSuccess(true);
    setResponse(response);
    console.log(response);
  }

  const handleScheduleToggle = (e) => {
    setFormData(prev => ({
      ...prev,
      metadata: { ...prev.metadata, schedule: { ...prev.metadata.schedule, enabled: e.target.checked } }
    }));
  };

  const handleScheduleDayToggle = (day) => {
    setFormData(prev => {
      const days = prev.metadata.schedule.days || [];
      const next = days.includes(day) ? days.filter(d => d !== day) : [...days, day].sort((a, b) => a - b);
      return { ...prev, metadata: { ...prev.metadata, schedule: { ...prev.metadata.schedule, days: next } } };
    });
  };

  const handleScheduleField = (field, value) => {
    setFormData(prev => ({
      ...prev,
      metadata: { ...prev.metadata, schedule: { ...prev.metadata.schedule, [field]: value } }
    }));
  };

  const handleTagChange = (newValue) => {

    setFormData({
      ...formData,
      metadata: {
        ...formData.metadata,
        selected_exclude_appointment_types: newValue || []
      }
    });
  };

  const handleCreateTag = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };

    setFormData(prev => ({
      ...prev,
      metadata: {
        ...prev.metadata,
        exclude_appointment_types: [...prev.metadata.exclude_appointment_types, newOption],
        selected_exclude_appointment_types: [...prev.metadata.selected_exclude_appointment_types, newOption]
      }
    }));
  };

  useEffect(() => {
    let loaded = false;
    if (response) {
      return () => loaded = true;
    }

    const fetchData = async () => {
      const data = await clientData(props.token, id);
      console.log(data);
      if (!loaded) {
        setResponse(data);
        const defaultSchedule = {
          enabled: false,
          days: [1, 2, 3, 4, 5],
          start_time: '09:00',
          end_time: '17:00',
          timezone: 'America/New_York',
        };
        if(!data.metadata){
          data.metadata = {
            send_txt: true,
            send_email: true,
            send_request_on_create: true,
            selected_exclude_appointment_types: [],
            exclude_appointment_types: [
              { value: 'Walk In', label: 'Walk In' },
              { value: 'New Patient', label: 'New Patient' },
              { value: 'Audio', label: 'Audio' },
              { value: 'Follow up', label: 'Follow up' }
            ],
            schedule: defaultSchedule,
          }
        }else{
          data.metadata = JSON.parse(data.metadata)
          if(data.metadata.send_request_on_create === undefined){
            data.metadata.send_request_on_create = true
          }
          if(data.metadata.exclude_appointment_types === undefined){
            data.metadata.selected_exclude_appointment_types = []
            data.metadata.exclude_appointment_types = [
              { value: 'Walk In', label: 'Walk In' },
              { value: 'New Patient', label: 'New Patient' },
              { value: 'Audio', label: 'Audio' },
              { value: 'Follow up', label: 'Follow up' }
            ]
          }
          if(data.metadata.schedule === undefined){
            data.metadata.schedule = defaultSchedule
          }
        }
        delete data['created_at'];
        delete data['updated_at'];
        setFormData(data);
      }
    }

    fetchData().catch(function(e) {
      console.log(e);
      setError(true);
    });

    return () => loaded = true;
  }, [props.token, response, id])

  return(
    <div>
      {error ?
        <div className="uk-alert-danger" uk-alert="">
            <p>Client error!</p>
        </div>
      : null}
      {success ?
        <div className="uk-alert-success" uk-alert="">
            <a className="uk-alert-close" uk-close=""></a>
            <p>Client edited successfully</p>
            <a href={'../' + id + '/'}>See client</a>
        </div>
      : null}
        <a href={'../' + id + '/'}>
          <button className="uk-button uk-button-default"><span uk-icon="arrow-left"></span> client</button>
        </a>
        <div className="uk-card uk-card-default uk-margin-top">
          <div className="uk-card-header">
              <h3 className="uk-card-title">Edit Client</h3>
          </div>
          <div className="uk-card-body">
            <form className="uk-form-horizontal" uk-grid="" onSubmit={handleSubmit}>
            <div className="" style={{width:'100%'}}>
              <div style={{width:'70%',float:'left'}}>
                <div className="uk-card-body">
                  <p><b>Company</b></p>
                  <div className="uk-width-1-1@s uk-width-1-expand@m">
                    <label className="uk-form-label" htmlFor="company_id">OMS</label>
                    <div className="uk-form-controls">
                      <select className="uk-select" id="company_id" value={formData['company_id']} onChange={handleInputChange}>
                        <option value="">Please select...</option>
                        <option value="4">SFTP</option>
                        <option value="3">Sycle</option>
                        <option value="2">CounselEar</option>
                        <option value="6">Suno</option>
                        <option value="7">Generic</option>
                        <option value="1">Blueprint</option>
                      </select>
                    </div>
                  </div>
                  <div className="uk-width-1-1@s uk-width-1-expand@m">
                    <label className="uk-form-label" htmlFor="clinic_id">Clinic ID</label>
                    <div className="uk-form-controls">
                      <input className="uk-input" id="clinic_id" type="text" placeholder="Clinic ID" value={formData['clinic_id']} onChange={handleInputChange}/>
                    </div>
                  </div>
                  <div className="uk-width-1-1@s uk-width-1-expand@m">
                    <label className="uk-form-label" htmlFor="name">Name</label>
                    <div className="uk-form-controls">
                      <input className="uk-input" id="name" type="text" placeholder="Name" value={formData['name']} onChange={handleInputChange}/>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{width:'30%',float:'left'}}>
                <div className="uk-card-body">
                  <p><b>Request Settings</b></p>
                  <div className="uk-column-1-2" style={{marginBottom: '8px'}}>
                    <div>
                      <span className="uk-column-span" style={{fontWeight: 'bold', color: formData.active ? '#32d296' : '#f0506e'}}>Active</span>
                    </div>
                    <div>
                      <label className="switch">
                        <input type="checkbox" id="active" checked={formData.active === 1 || formData.active === true} onChange={handleActiveToggle}/>
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <hr style={{margin: '8px 0'}}/>
                  <div className="uk-column-1-2" >
                    <div>
                      <span className="uk-column-span" style={{width: "25px"}} >TXT</span>
                    </div>
                    <div>
                      <label className="switch">
                        <input type="checkbox" id="send_txt" checked={(formData.metadata?.send_txt)?formData.metadata?.send_txt:false} onChange={handleInputCheckChange}/>
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div className="uk-column-1-2">
                    <div>
                      <span className="uk-column-span">eMail</span>
                    </div>
                    <div>
                      <label className="switch">
                        <input type="checkbox" id="send_email" checked={(formData.metadata?.send_email)?formData.metadata?.send_email:false} onChange={handleInputCheckChange}/>
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                    <div className="uk-column-1-2" >
                        <div>
                            <span className="uk-column-span" style={{width: "25px"}} >Send On Create</span>
                        </div>
                        <div>
                            <label className="switch">
                                <input type="checkbox" id="send_request_on_create" checked={(formData.metadata?.send_request_on_create)?formData.metadata?.send_request_on_create:false} onChange={handleInputCheckChange}/>
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                  <div className="uk-margin-top">
                    <div>
                      <span className="uk-column-span" style={{width: "25px"}} >Exclude Appointment Types</span>
                    </div>

                    <CreatableSelect
                        isMulti
                        isSearchable
                        placeholder="Search or type to add..."
                        value={formData.metadata.selected_exclude_appointment_types}
                        onChange={handleTagChange}
                        onCreateOption={handleCreateTag}
                        options={formData.metadata.exclude_appointment_types}
                        className="uk-margin-small-top"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: '#e5e5e5',
                            borderRadius: '0px', // Matches UIKit style
                          }),
                        }}
                    />
                  </div>
                </div>
              </div>
            </div>


            <div className="uk-width-1-1@s uk-width-1-1@m uk-margin-top">
              <hr/>
              <p><b>Message Schedule</b></p>
              <div className="uk-column-1-2">
                <div><span className="uk-column-span">Enable Schedule</span></div>
                <div>
                  <label className="switch">
                    <input type="checkbox" checked={!!formData.metadata?.schedule?.enabled} onChange={handleScheduleToggle}/>
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
              {formData.metadata?.schedule?.enabled && (
                <div className="uk-margin-small-top">
                  <div className="uk-margin-small-bottom">
                    <span style={{marginRight: '8px'}}><b>Days:</b></span>
                    {SCHEDULE_DAYS.map(d => (
                      <label key={d.value} style={{marginRight: '12px', cursor: 'pointer'}}>
                        <input
                          type="checkbox"
                          checked={(formData.metadata?.schedule?.days || []).includes(d.value)}
                          onChange={() => handleScheduleDayToggle(d.value)}
                          style={{marginRight: '4px'}}
                        />
                        {d.label}
                      </label>
                    ))}
                  </div>
                  <div className="uk-grid uk-grid-small" uk-grid="">
                    <div>
                      <label className="uk-form-label">Start Time</label>
                      <input className="uk-input uk-form-width-small" type="time" value={formData.metadata?.schedule?.start_time || '09:00'} onChange={e => handleScheduleField('start_time', e.target.value)}/>
                    </div>
                    <div>
                      <label className="uk-form-label">End Time</label>
                      <input className="uk-input uk-form-width-small" type="time" value={formData.metadata?.schedule?.end_time || '17:00'} onChange={e => handleScheduleField('end_time', e.target.value)}/>
                    </div>
                    <div>
                      <label className="uk-form-label">Timezone</label>
                      <select className="uk-select uk-form-width-medium" value={formData.metadata?.schedule?.timezone || 'America/New_York'} onChange={e => handleScheduleField('timezone', e.target.value)}>
                        {SCHEDULE_TIMEZONES.map(tz => <option key={tz} value={tz}>{tz}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="uk-width-1-1@s uk-width-1-1@m uk-margin-top">
              <button className="uk-button uk-button-default" type="submit">Submit</button>
            </div>
          </form>
          </div>
        </div>
    </div>
  );
}
